import {Navigate, Route, Routes} from 'react-router-dom';
import Login from '../../auth/Login';
import ProtectedRoute from '../ProtectedRoute';
import AppMenu from '../AppMenu';
import Dashboard from '../../../pages/Dashboard';
import TransactionsPage from '../../../pages/TransactionsPage';
import ProjectsPage from '../../../pages/ProjectsPage';
import AccountsPage from '../../../pages/AccountsPage';
import MilestonesPage from '../../../pages/MilestonesPage';
import TaxConfigPage from '../../../pages/TaxConfigPage';
import TimelinePage from '../../../pages/TimelinePage';
import CurrencyRatePage from '../../../pages/CurrencyRatePage';

function App() {
    return (
        <Routes>
            <Route path="login" element={<Login/>}/>
            <Route element={<ProtectedRoute/>}>
                <Route element={<AppMenu/>}>
                    <Route path="dashboard"     element={<Dashboard/>}/>
                    <Route path="transactions"  element={<TransactionsPage/>}/>
                    <Route path="projects"      element={<ProjectsPage/>}/>
                    <Route path="accounts"      element={<AccountsPage/>}/>
                    <Route path="milestones"    element={<MilestonesPage/>}/>
                    <Route path="tax"           element={<TaxConfigPage/>}/>
                    <Route path="currency"      element={<CurrencyRatePage/>}/>
                    <Route path="timeline"      element={<TimelinePage/>}/>
                    <Route path="*" element={<Navigate to="dashboard" replace/>}/>
                </Route>
            </Route>
        </Routes>
    );
}

export default App;